import { useState } from "react"
import { Button } from "@/components/ui/button"

type AccountType = "individual" | "agency"

export default function AccountTypeStep({
  currentType,
  onNext,
}: {
  currentType: string
  onNext: (type: AccountType) => void
}) {
  const [selected, setSelected] = useState<AccountType>(
    (currentType as AccountType) || "individual"
  )

  return (
    <div className="text-center">
      <h2 className="font-display text-3xl font-semibold tracking-tight text-charcoal sm:text-4xl">
        How will you use QuiteRight?
      </h2>
      <p className="mt-3 text-warm-grey">
        This helps us tailor your experience. You can change this later.
      </p>

      <div className="mx-auto mt-10 grid max-w-lg gap-4 sm:grid-cols-2">
        <button
          type="button"
          onClick={() => setSelected("individual")}
          className={`group rounded-2xl border-2 px-6 py-8 text-left transition-all duration-200 ${
            selected === "individual"
              ? "border-red bg-red/5 shadow-sm"
              : "border-stone/40 bg-white hover:border-stone"
          }`}
        >
          <div className="mb-4 flex size-12 items-center justify-center rounded-xl bg-stone/30 text-2xl">
            <svg className="size-6 text-charcoal" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
            </svg>
          </div>
          <p className="font-display text-lg font-semibold text-charcoal">
            Individual
          </p>
          <p className="mt-1.5 text-sm text-warm-grey">
            Independent agent, landlord, or property owner
          </p>
        </button>

        <button
          type="button"
          onClick={() => setSelected("agency")}
          className={`group rounded-2xl border-2 px-6 py-8 text-left transition-all duration-200 ${
            selected === "agency"
              ? "border-red bg-red/5 shadow-sm"
              : "border-stone/40 bg-white hover:border-stone"
          }`}
        >
          <div className="mb-4 flex size-12 items-center justify-center rounded-xl bg-stone/30 text-2xl">
            <svg className="size-6 text-charcoal" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" />
            </svg>
          </div>
          <p className="font-display text-lg font-semibold text-charcoal">
            Agency
          </p>
          <p className="mt-1.5 text-sm text-warm-grey">
            Estate agency or letting agency with a team
          </p>
        </button>
      </div>

      <Button
        onClick={() => onNext(selected)}
        className="mt-10 bg-red px-10 py-5 text-sm font-semibold text-white hover:bg-red-deep"
      >
        Continue
      </Button>
    </div>
  )
}
